import { createBrand, getBrandStatus, getBrandVisualAsset, updateBrandVisualAsset } from './brand.utils';
import Vue from 'vue';

function getInitialBrandState () {
    return {
        requestId: null,
        visualAssetId: null,
    };
}

const brand = {
    namespaced: true,
    state: {
        currentBrand: getInitialBrandState(),
        map: {},
        error: null,
    },
    mutations: {
        updateGroup (state, { type, items }) {
            const group = state.map[state.currentBrand.visualAssetId]?.assets?.find((group) => group.type === type);

            if (group) {
                group.items = items;
            }
        },
        setBrandRequestId (state, { requestId }) {
            state.currentBrand.requestId = requestId;
        },
        setBrandVisualAssetId (state, { visualAssetId }) {
            state.currentBrand.visualAssetId = visualAssetId;
        },
        setBrandVisualAsset (state, { visualAssetId, visualAsset }) {
            Vue.set(state.map, visualAssetId, visualAsset);
        },
        setError (state, { error }) {
            state.error = error;
        },
        resetBrandSettings (state) {
            Object.assign(state.currentBrand, getInitialBrandState());
        },
    },
    actions: {
        async createBrand ({ commit }, { url = '' }) {
            try {
                const { data } = await createBrand(url.toLowerCase());
                const { requestId } = data;
                commit('setBrandRequestId', { requestId });
            } catch (error) {
                commit('setError', { error });
            }
        },
        async fetchBrandStatus ({ commit }, { requestId }) {
            try {
                const { data } = await getBrandStatus(requestId);
                const { visualAssetId, error } = data;

                if (visualAssetId) {
                    commit('setBrandVisualAssetId', { visualAssetId });
                }
                if (error) {
                    commit('setError', { error });
                }
            } catch (error) {
                commit('setError', { error });
            }
        },
        async fetchBrandVisualAsset ({ commit }, { visualAssetId }) {
            try {
                const { data } = await getBrandVisualAsset(visualAssetId);
                commit('setBrandVisualAsset', { visualAssetId, visualAsset: data[0] });
            } catch (error) {
                commit('setError', { error });
            }
        },
        async updateBrandVisualAsset ({ commit }, { visualAssetId, assets }) {
            try {
                await updateBrandVisualAsset(visualAssetId, assets);
            } catch (error) {
                commit('setError', { error });
            }
        },
    },
    getters: {
        getGroup: (state) => (type) =>
            state.map[state.currentBrand.visualAssetId]?.assets?.find((group) => group.type === type)?.items || [],
        getBrandRequestId: (state) => state.currentBrand.requestId,
        getBrandVisualAssetId: (state) => state.currentBrand.visualAssetId,
        getBrandVisualAsset: (state) => state.map[state.currentBrand.visualAssetId],
        getError: (state) => state.error,
    },
};

export default brand;
